import "./footer.css";
import { Link } from "react-router-dom";
import { Container, Grid, Header } from "semantic-ui-react";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="footer-section">
            <Container className="footer">
                <Grid doubling stackable>
                    <Grid.Row columns={2} verticalAlign="top">
                        <Grid.Column verticalAlign="top" textAlign="center">
                            <Header as="h1" content="VIS GROUP" className="footer-h1" />
                            <Header as="h2" content="HVAC Specialists" className="footer-h2" />
                            <Header as="h3" content="Installation & Contracting" className="footer-h3" />
                            <div className="footer-address-block">
                                <p className="footer-details">VIS Ventilation Industrial Systems Ltd</p>
                                <p className="footer-details">41 Rothersthorpe Avenue</p>
                                <p className="footer-details">Northampton NN4 8JH</p>
                                <p className="footer-details">United Kingdom</p>
                            </div>
                            <div className="footer-legal-links">
                                <Link to="/legal-notice" className="footer-legal-link">
                                    Legal Notice
                                </Link>
                                <Link to="/data-protection" className="footer-legal-link">
                                    Data Protection
                                </Link>
                            </div>
                        </Grid.Column>
                        <Grid.Column verticalAlign="middle" textAlign="center">
                            <div className="footer-details-block">
                                <div className="footer-person">
                                    <p className="footer-details">Ion Cecoi</p>
                                    <p className="footer-details">
                                        <a href="tel:+441604217969" className="footer-contact-link">
                                            +44 1604 217969
                                        </a>
                                    </p>
                                    <p className="footer-details">
                                        <a href="mailto:ioncecoi@visgroup.co.uk" className="footer-contact-link">
                                            ioncecoi@visgroup.co.uk
                                        </a>
                                    </p>
                                </div>
                                <div className="footer-person">
                                    <p className="footer-details">Vasili Butnaru</p>
                                    <p className="footer-details">
                                        <a href="tel:+447850048527" className="footer-contact-link">
                                            +44 7850 048527
                                        </a>
                                    </p>
                                    <p className="footer-details">
                                        <a href="mailto:vasilibutnaru@visgroup.co.uk" className="footer-contact-link">
                                            vasilibutnaru@visgroup.co.uk
                                        </a>
                                    </p>
                                </div>
                                <div className="footer-person">
                                    <p className="footer-details">Ali Hamza</p>
                                    <p className="footer-details">
                                        <a href="tel:+441604213217" className="footer-contact-link">
                                            +44 1604 213217
                                        </a>
                                    </p>
                                    <p className="footer-details">
                                        <a href="mailto:alihamza@visgroup.co.uk" className="footer-contact-link">
                                            alihamza@visgroup.co.uk
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={1} textAlign="center">
                        <Grid.Column>
                            <p className="footer-copy-rights">
                                © {currentYear} Powered by<span> </span>
                                <a
                                    href="https://maximdomentii.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="powered-by"
                                >
                                    maximdomentii.com
                                </a>
                            </p>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </div>
    );
};

export default Footer;
